import propTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Title, Subtitle, Col, ButtonLink } from '../styles';
import CountdownRing from './components/CountdownRing';
import { useWorkstationPendingFlow } from './hooks';
import { PENDING_SUBSTATE } from './constants';
import WorkstationApprovedSuccess from './components/WorkstationApprovedSuccess';
import WorkstationTryAgain from './components/WorkstationTryAgain';

const LoginWorkstationPending = ({ values, setCurrentStep, steps }) => {
  const [t] = useTranslation('login');
  const { subState } = useWorkstationPendingFlow();

  if (subState === PENDING_SUBSTATE.SUCCESS) {
    return (
      <WorkstationApprovedSuccess
        onLogin={() => setCurrentStep(steps.password)}
      />
    );
  }

  if (subState === PENDING_SUBSTATE.TRY_AGAIN) {
    // Com mais de uma opção elegível (condomínio ou Parceiro) e nenhuma
    // ainda escolhida (ex.: quem entrou direto pelo Pending de uma sessão
    // anterior, sem passar pelo dropdown), o passo de seleção precisa vir
    // antes do cadastro — senão o register segue com o contexto nulo e a
    // mutation falha. Condomínio é avaliado antes de Parceiro, na mesma
    // ordem de routeWorkstationOutcome (hooks/useLoginActions.js).
    const hasUnresolvedCondominiumChoice =
      !values.condominiumContextId && (values.condominiums || []).length > 1;
    const hasUnresolvedPartnerChoice =
      !values.partnerContextId && (values.partners || []).length > 1;

    let nextStep = steps.workstationRegister;
    if (hasUnresolvedCondominiumChoice) {
      nextStep = steps.workstationCondominiumSelect;
    } else if (hasUnresolvedPartnerChoice) {
      nextStep = steps.workstationPartnerSelect;
    }

    return (
      <WorkstationTryAgain
        onRequestAgain={() => setCurrentStep(nextStep)}
        onBack={() => setCurrentStep(steps.email)}
      />
    );
  }

  return (
    <Col>
      <Title>{t('workstation.pending.title')}</Title>
      <Subtitle>{t('workstation.pending.subtitle')}</Subtitle>
      <Subtitle>
        <CountdownRing />
        {t('workstation.pending.checking')}
      </Subtitle>
      <ButtonLink color="link" onClick={() => setCurrentStep(steps.email)}>
        {t('workstation.pending.back')}
      </ButtonLink>
    </Col>
  );
};

export default LoginWorkstationPending;

LoginWorkstationPending.propTypes = {
  values: propTypes.shape({
    partnerContextId: propTypes.number,
    partners: propTypes.arrayOf(propTypes.object),
    condominiumContextId: propTypes.number,
    condominiums: propTypes.arrayOf(propTypes.object),
  }).isRequired,
  setCurrentStep: propTypes.func.isRequired,
  steps: propTypes.objectOf(
    propTypes.shape({
      component: propTypes.elementType,
      key: propTypes.string,
    }),
  ).isRequired,
};
